import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputMask} from "primereact/inputmask";
import moment from "moment";
import {Calendar} from "primereact/calendar";
import { AutoComplete } from 'primereact/autocomplete';

const PurchaserequestFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [newFormData, setNewFormData] = useState({});
  const [profile, setProfile] = useState({});
  const [locations, setLocations] = useState([]);
  const [projectItems, setProjectItems] = useState([]);
  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [requestedByDisplay, setRequestedByDisplay] = useState("");
  const [requestedBySuggestions, setRequestedBySuggestions] = useState([]);

  const [projectDisplay, setProjectDisplay] = useState("");
  const [projectSuggestions, setProjectSuggestions] = useState([]);
  const [projectSelected, setProjectSelected] = useState(false);

  const purchaseRequestId = window.App.urlVars().purchaserequestId ?? id;

  const urlVars = window.App.urlVars?.() ?? {};
  const createTypeFromUrl =
    urlVars.type === 'PROJECT' || urlVars.type === 'INVENTORY'
      ? urlVars.type
      : undefined;

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().purchaserequestId) || (entity === 'purchase-request' && id)) {
      apiCall('patch', '/api/v2/purchase-order-request/' + (window.App.urlVars().purchaserequestId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPurchaserequestList: Math.random()})
          if (props.goback === true) {
            history.push(window.App.urlVars().return);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {

      const payload = {
        ...data,
        reference_type: formData.reference_type || createTypeFromUrl || 'PROJECT',
        project: (formData.reference_type || createTypeFromUrl || 'PROJECT') === 'PROJECT'
          ? (formData.project || data.project || null)
          : null,
        project_item: formData.project_item ?? data.project_item ?? null,
        requested_by: formData.requested_by || data.requested_by || null,
        note: data.note ?? formData.note ?? null,
      };

      apiCall('post', '/api/v2/purchase-order-request', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPurchaserequestList: Math.random()})
          if (props.goback === true) {
            history.push('/procurement/purchase-request/read/' + response.data.data.id);
          } else {
            history.push('/procurement/purchase-request/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };
  

  const minDeadlineDate = (() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1);
    return d;
  })();

  const [formData, setFormData] = useState({
    deadline: moment().add(7, 'days').toDate(),
    reference_type: undefined,
  });

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  const getProjectLocationId = (project) => {
    if (!project) return null;
    if (project.location && typeof project.location === 'object' && project.location.id) {
      return project.location.id;
    }
    if (project.location && (typeof project.location === 'number' || typeof project.location === 'string')) {
      return project.location;
    }
    if (project.location_id) return project.location_id;
    if (Array.isArray(project.locations) && project.locations[0]?.id) {
      return project.locations[0].id;
    }
    return null;
  };
  
  const applyProjectLocation = (projectOrId) => {
    if (window.App.urlVars().locationId && !id) return;
    let projectObj = null;
    if (typeof projectOrId === 'object') {
      projectObj = projectOrId;
    } else if (projectOrId) {
      projectObj = projects.find(p => String(p.id) === String(projectOrId));
    }
    const locId = getProjectLocationId(projectObj);
    setFormData(prev => ({ ...prev, location: locId || null }));
    setNewFormData(prev => ({ ...prev, location: locId || null }));
  };

  const searchRequestedBy = (event) => {
    const query = (event.query || "").toLowerCase().trim();

    if (!query) {
      setRequestedBySuggestions([]);
      return;
    }

    const filtered = employees
      .filter(emp => {
        const name = (emp.name || "").toLowerCase();
        return name.includes(query);
      })
      .map(emp => ({
        ...emp,
        name: emp.name
      }));

    setRequestedBySuggestions(filtered);
  };

  const searchProject = (event) => {
    const query = (event.query || "").toLowerCase().trim();

    if (!query) {
      setProjectSuggestions([]);
      return;
    }

    const filtered = projects
      .filter(p => {
        const name = (p.name || "").toLowerCase();
        return name.includes(query);
      })
      .map(p => ({
        ...p,
        name: p.name
      }));

    setProjectSuggestions(filtered);
  };

  useEffect(() => {
    const projectId = formData?.project?.id || formData?.project;
    if (projectId) {
      apiCall('GET', '/api/v2/location?search[project_or_central][operator]==&search[project_or_central][value]=' + projectId)
        .then(response => {
          setLocations(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString());
        });
    } else {
      setLocations([]);
    }
  }, [formData?.project]);

  useEffect(() => {
    const projectId = formData?.project?.id || formData?.project;
    if (projectId) {
      apiCall('GET', '/api/v2/project-item?search[project][operator]==&search[project][value]=' + projectId)
        .then(response => {
          setProjectItems(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString());
        });
    } else {
      setProjectItems([]);
    }
  }, [formData?.project]);

  useEffect(() => {
    apiCall('GET', '/api/v2/profile')
      .then(response => {
        setProfile(response.data.data);
        const employeeId = response?.data?.data?.employee?.id;
        const employeeName = response?.data?.data?.employee?.name;
        if (employeeId) {
          localStorage.setItem('employeeId', employeeId);
        }
        if (employeeName) {
          localStorage.setItem('employeeName', employeeName);
        }
        if (!purchaseRequestId || purchaseRequestId === 'undefined') {
          setFormData(prev => ({
            ...prev,
            requested_by: employeeId || prev.requested_by
          }));
          setNewFormData(prev => ({
            ...prev,
            requested_by: employeeId || prev.requested_by
          }));
          if (employeeName) {
            setRequestedByDisplay(employeeName);
          }
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [purchaseRequestId]);

  useEffect(() => {
    const employeeId = localStorage.getItem('employeeId');
    console.log('employeeId from localStorage:', employeeId);
    console.log('employees length:', employees.length);
    if (!purchaseRequestId || purchaseRequestId === 'undefined') {
      if (employeeId && employees.length > 0 && !formData.requested_by) {
        const emp = employees.find(e => String(e.id) === String(employeeId));
        console.log('matched employee:', emp);
        if (emp) {
          setRequestedByDisplay(emp.name || '');
          setFormData(prev => ({
            ...prev,
            requested_by: emp.id
          }));
          setNewFormData(prev => ({
            ...prev,
            requested_by: emp.id
          }));
        }
      }
    }
  }, [employees, purchaseRequestId, formData.requested_by]);

  useEffect(() => {
    if (!formData?.project) return;
    if (!projects || projects.length === 0) return;
    applyProjectLocation(formData.project);
  }, [formData?.project, projects?.length]);

  useEffect(() => {

    if ((urlVars.create === 'purchaserequest' || action === 'create') && !id) {
      setFormData(prev => ({
        ...prev,
        reference_type: createTypeFromUrl,
      }));
    }

    // apiCall('GET', '/api/v2/location?limit=9999')
    //   .then(response => {
    //     setLocations(response.data.data.items)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //   })
    apiCall('GET', '/api/v2/project?limit=9999')
      .then(response => {
        setProjects(response.data.data.items)
        if (formData?.project && typeof formData.project === 'object') {
          setProjectDisplay(formData.project.name || "");
        } else if (formData?.project) {
          const hitProj = response.data.data.items.find(p => String(p.id) === String(formData.project));
          if (hitProj) {
            setProjectDisplay(hitProj.name || "");
          }
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/employee?limit=1000')
      .then(response => {
        const list = response.data?.data?.items || [];
        setEmployees(list)
        if (formData?.requested_by && typeof formData.requested_by === 'object') {
          setRequestedByDisplay(formData.requested_by.name || "");
        } else if (formData?.requested_by) {
          const hit = list.find(emp => String(emp.id) === String(formData.requested_by));
          if (hit) {
            setRequestedByDisplay(hit.name || "");
          }
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().purchaserequestId) || (entity === 'purchase-request' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order-request/' + (window.App.urlVars().purchaserequestId ?? id))
        .then(response => {
          setFormData(response.data.data)
          const data = response.data.data;
          if (data?.requested_by && typeof data.requested_by === 'object') {
            setRequestedByDisplay(data.requested_by.name || "");
          } else if (data?.requested_by) {
            const hit = employees.find(emp => String(emp.id) === String(data.requested_by));
            if (hit) {
              setRequestedByDisplay(hit.name || "");
            }
          }
          if (data?.project && typeof data.project === 'object') {
            setProjectDisplay(data.project.name || "");
          } else if (data?.project) {
            const hitProj2 = projects.find(p => String(p.id) === String(data.project));
            if (hitProj2) {
              setProjectDisplay(hitProj2.name || "");
            }
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderPurchaserequestForm])

  useEffect(() => {
    if (formData?.reference_type === 'INVENTORY' && formData?.project) {
      setFormData(prev => ({...prev, project: null}));
      setNewFormData(prev => ({...prev, project: null}));
    }
  }, [formData?.reference_type]);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.employeeName) {
      const decodedName = decodeURIComponent(vars.employeeName);

      setRequestedByDisplay(decodedName);

      setFormData(prev => ({
        ...prev,
        requested_by: vars.employeeId || prev.requested_by
      }));

      setNewFormData(prev => ({
        ...prev,
        requested_by: vars.employeeId || prev.requested_by
      }));
    }
    if (vars.projectName) {
      const decodedProjName = decodeURIComponent(vars.projectName);

      setProjectDisplay(decodedProjName);

      setFormData(prev => ({
        ...prev,
        project: vars.projectId || prev.project
      }));

      setNewFormData(prev => ({
        ...prev,
        project: vars.projectId || prev.project
      }));
    }
  }, [window.App.urlVars().employeeName, window.App.urlVars().projectName]);

  return (
    <div className={"purchaserequest-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {/* <div className={"p-col-12 p-lg-3"}>
              <Field name="reference_type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="reference_type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldReferenceType')}</label>
                  <span className="p-d-block">
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    reference_type: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    reference_type: e.target.value
                                  })

                                }}
                                value={formData.reference_type?.id || formData.reference_type}
                                options={window.App.sortDropdownOptions([
                                  {
                                    label: props.t('project'),
                                    key: "PROJECT",
                                  },
                                  {
                                    label: "Készlet",
                                    key: "INVENTORY",
                                  }
                                ], "label")}
                                optionLabel="label"
                                optionValue="key"
                                id={"reference_type"}
                                emptyMessage={t('noTargetYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}
            {formData.requested_by && formData?.reference_type === 'PROJECT' && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="project" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="project"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('project')}</label>
                    {/*
                  <span className={"p-d-block"}>
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            project: e.target.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            project: e.target.value
                                          })
                                        }}
                                        value={formData?.project?.id || formData.project}
                                        options={window.App.sortDropdownOptions(projects, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"project"}
                                        emptyMessage={t('noProjectYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  */}
                    <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        let paramsObj = {...window.App.urlVars()};
                        paramsObj.search = 'project';
                        let _params = "?";
                        Object.entries(paramsObj).forEach(([key, value]) => {
                          _params += key + "=" + value + "&";
                        });
                        history.push(window.location.hash.replace("#", "") + _params);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>

                    <AutoComplete
                      id="project"
                      value={projectDisplay}
                      suggestions={projectSuggestions}
                      completeMethod={searchProject}
                      field={"name"}
                      delay={800}
                      forceSelection
                      placeholder={t('projectTypeToSearchPlaceholder')}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}

                      onSelect={(e) => {
                        const picked = e.value;
                        setProjectSelected(true);
                        setProjectDisplay(picked.name || "");
                        const pickedProjectId = picked.id || null;
                        const pickedLocationId = picked.location?.id || null;
                        setFormData(prev => ({
                          ...prev,
                          project: pickedProjectId,
                          location: pickedLocationId || null
                        }));
                        setNewFormData(prev => ({
                          ...prev,
                          project: pickedProjectId,
                          location: pickedLocationId || null
                        }));
                        applyProjectLocation(picked);
                      }}

                      onChange={(e) => {
                        if (projectSelected) {
                          setProjectSelected(false);
                          return;
                        }
                        setProjectDisplay(e.value);

                        setFormData({
                          ...formData,
                          project: null
                        });
                        setNewFormData({
                          ...newFormData,
                          project: null
                        });
                      }}

                      onClear={() => {

                        setProjectDisplay("");
                        setFormData({
                          ...formData,
                          project: null,
                          location: null
                        });
                        setNewFormData({
                          ...newFormData,
                          project: null,
                          location: null
                        });
                      }}
                    />
                  </span>

                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            <div className={"p-col-12 p-lg-6"}>
              <Field name="location" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="location"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDeliveryAddress')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            location: e.target.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            location: e.target.value
                                          })
                                        }}
                                        value={formData?.location?.id || formData.location}
                                        options={window.App.sortDropdownOptions(locations, "name")}
                                        filter
                                        // disabled={!(formData?.project) ||window.App.urlVars().locationId || id}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"location"}
                                        emptyMessage={t('noLocationYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="project_item" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="project_item"
                        className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('technology')}</label>

                  <span className={"p-d-block"}>
                    <Dropdown
                      {...input}
                      onChange={(e) => {
                        input.onChange(e.target.value);

                        setFormData(prev => ({
                          ...prev,
                          project_item: e.target.value
                        }));
                        setNewFormData(prev => ({
                          ...prev,
                          project_item: e.target.value
                        }));
                      }}
                      value={formData?.project_item?.id || formData?.project_item || null}
                      options={window.App.sortDropdownOptions(projectItems, "name")}
                      filter
                      // disabled={!(formData?.project) || !!id}
                      optionLabel="name"
                      optionValue="id"
                      id={"project_item"}
                      emptyMessage={`${t('noYetPrefix')} ${t('technology')}...`}
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    />
                  </span>

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="deadline" render={({input, meta}) => (
                <span className="p-field p-fluid">
                    <label htmlFor="deadline"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('deadline')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"deadline"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={moment.utc(formData.deadline).local().format('YYYY-MM-DD')}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             deadline: new Date(e.value)
                                           })
                                           setNewFormData({
                                             ...newFormData,
                                             deadline: new Date(e.value)
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.deadline}
                                      locale="hu"
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      minDate={minDeadlineDate}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          deadline: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          deadline: e.value
                                        })
                                      }}/>
                    </div>
                  {getFormErrorMessage(meta)}
                  </span>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="requested_by" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="requested_by"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRequestedBy')}</label>
                  {/*
                  <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    requested_by: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    requested_by: e.target.value
                                  })
                                }}
                                value={formData?.requested_by?.id || formData.requested_by}
                                options={window.App.sortDropdownOptions(employees, "name")}
                                optionLabel="name"
                                optionValue="id"
                                id={"requested_by"}
                                emptyMessage={t('noRequesterYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                  </span>
                  */}
                  <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        // let paramsObj = {...window.App.urlVars()};
                        // paramsObj.search = 'user';
                        let _params = "?";
                        Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                          _params += key + "=" + value + "&";
                        });
                        _params += "search=employee";
                        history.push(window.location.hash.replace("#", "") + _params);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>

                    <AutoComplete
                      id="requested_by"
                      value={requestedByDisplay}
                      suggestions={requestedBySuggestions}
                      completeMethod={searchRequestedBy}
                      field={"name"}
                      delay={800}
                      forceSelection
                      placeholder={t('typeToSearchPlaceholder')}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}

                      onSelect={(e) => {
                        const picked = e.value;
                        setRequestedByDisplay(picked.name || "");

                        setFormData({
                          ...formData,
                          requested_by: picked.id
                        });
                        setNewFormData({
                          ...newFormData,
                          requested_by: picked.id
                        });
                      }}

                      onChange={(e) => {
                        setRequestedByDisplay(e.value);
                        setFormData({
                          ...formData,
                          requested_by: null
                        });
                        setNewFormData({
                          ...newFormData,
                          requested_by: null
                        });
                      }}
                      onClear={() => {
                        setRequestedByDisplay("");
                        setFormData({
                          ...formData,
                          requested_by: null
                        });
                        setNewFormData({
                          ...newFormData,
                          requested_by: null
                        });
                      }}
                    />
                  </span>

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                        className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                    <InputText
                      id="note"
                      name={input.name}
                      value={input.value ?? formData.note ?? ''}
                      onChange={(e) => {
                        input.onChange(e.target.value);
                        setFormData(prev => ({
                          ...prev,
                          note: e.target.value,
                        }));
                        setNewFormData(prev => ({
                          ...prev,
                          note: e.target.value,
                        }));
                      }}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              {/* {entity === 'purchase-request' &&
                <Button type="button" label="Beszerzési igény lezárása"
                        loading={loading}
                        icon={"pi pi-lock"}
                        disabled={formData.status === 'DONE'}
                        className="p-button-warning p-ml-2"
                        onClick={() => {
                          setLoading(true)
                          apiCall('patch', '/api/v2/purchase-order-request/' + id, {
                            status: 'DONE'
                          })
                            .then(response => {
                              window.App.setState({
                                rerenderPurchaserequestList: Math.random(),
                                rerenderPurchaserequestForm: Math.random(),
                                rerenderPurchaserequestDnd: Math.random(),
                              })
                              window.App.toastShow('success', 'Sikeres mentés!');
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                            })
                            .finally(() => {
                              setLoading(false);
                            });
                        }}
                />
              } */}
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {/*{entity === 'purchase-request' &&*/}
              {/*  <Button type="submit" label={t('save')}*/}
              {/*          loading={loading}*/}
              {/*          icon={"pi pi-save"}*/}
              {/*          className="p-button-success p-ml-2"/>*/}
              {/*}*/}
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PurchaserequestFormComponent);
